"use client";

// PanelBoundary — one space tripping never takes the dashboard with it.
//
// Before this, the dashboard had no boundary below the root: a render error in
// any panel (a list, the river, a sheet) unwound the whole app to the global
// error page, and it read as "the site is down". Now the navigator, the crumb,
// netti and every other space stay alive, and the space that tripped keeps the
// last good thing you were looking at while it is put back together.
//
// It is SafeBoundary with the panel's settings: keep the last render, remount
// quietly after 0.8s / 2.5s / 6s, then NettiError with a button. "Open it
// again" is a real second attempt: if the panel's code failed to download, the
// loader is re-armed first (rearmable in SafeBoundary), because React.lazy would
// otherwise hand back the same rejected import forever.
//
// Keyed by the level's path in the shell, so moving to another space always
// starts clean. Every catch is reported (PostHog error tracking), so a trip is
// something we see, not something a person has to tell us about.

import type { ReactNode } from "react";
import SafeBoundary from "./SafeBoundary";

// kept here because the dashboard's own error file has always imported it from
// this module; the implementation moved to lib/os/reportError.
export { reportClientError } from "../../lib/os/reportError";

export default function PanelBoundary({ children, where = "panel" }: { children: ReactNode; where?: string }) {
  return (
    <SafeBoundary where={where} keepLast>
      {children}
    </SafeBoundary>
  );
}
